// src/page-rects.ts
// Computes page dimensions for RequestType.GET_PAGE_RECTS (page redaction
// marking). Dimensions are returned in the stored-markup coordinate space:
// scale 1 (CSS px, 96 DPI), default page rotation (no orientation override) —
// i.e. page.getViewport({ scale: 96/72 }), same convention as find-match-rects.
import { PageRectsResponse } from './shared/model/docavea-viewer-interface';

const CSS_UNITS = 96.0 / 72.0;

export async function getPageRects(pdfDocument: any, pages: number[]): Promise<PageRectsResponse> {
    const response: PageRectsResponse = { requested: pages, pages: [], pagesFailed: 0 };
    for (const pageNumber of pages) {
        if (!Number.isInteger(pageNumber) || pageNumber < 1 || pageNumber > pdfDocument.numPages) {
            response.pagesFailed++;
            continue;
        }
        try {
            const page = await pdfDocument.getPage(pageNumber);
            const viewport = page.getViewport({ scale: CSS_UNITS });
            response.pages.push({ pageNumber, width: viewport.width, height: viewport.height });
        } catch (err) {
            console.error(`getPageRects: page ${pageNumber} failed`, err);
            response.pagesFailed++;
        }
    }
    return response;
}
